import { useEffect, useState } from "react"
import SelectDropdown from "../../common/SelectDropdown"
import ApiClient from "../../methods/api/apiClient"
import { useSelector } from "react-redux"
import loader from "../../methods/loader"
import Pagination from "react-js-pagination";

const EventTicketTable = ({ eventList }) => {
    const user = useSelector((state) => state.user)
    const [eventTicketsData, setEventTicketsData] = useState([])
    const [filter, setFilter] = useState({ page: 1, count: 10, eventId: "", userId: user?._id || user?.id })
    const [total, setTotal] = useState(0)
    const [expandedRows, setExpandedRows] = useState({});

    const eventTypeOption = [
        { id: "upcoming", name: "Upcoming Events" },
        { id: "past", name: "Past Events" },
    ]

    useEffect(() => {
        getEventTicketData()
    }, [])

    const getEventTicketData = (f = {}) => {
        const payload = { ...filter, ...f }
        loader(true)
        ApiClient.get(`analytic/total/ticket/data`, payload).then(res => {
            if (res.success) {
                setEventTicketsData(res?.data)
                setTotal(res?.total)
            }
            loader(false)
        })
    }

    const handleFilters = (e, key) => {
        setFilter({ ...filter, [key]: e, page: 1 });
        getEventTicketData({ [key]: e, page: 1 });
    }

    const handlePagination = (e) => {
        setFilter((prev) => ({ ...prev, page: e }))
        getEventTicketData({ page: e })
    }


    const toggleRow = (index) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    return (
        <>
            <div className="bg-white shadow-xl rounded-xl mb-5">
                <div className="flex gap-x-5 justify-between flex-wrap items-center border-b border-gray-200 min-h-[53px] px-5 py-3">
                    <div className="font-semibold text-[#005fa7]">Event/Tickets Data</div>
                    <div className="flex gap-2 flex-wrap justify-end ml-auto">
                        <SelectDropdown
                            id="statusDropdown"
                            displayValue="name"
                            theme="search"
                            placeholder="Select Event"
                            intialValue={filter?.eventId}
                            isClearable={true}
                            result={(e) => handleFilters(e.value, "eventId")}
                            options={eventList}
                        />
                        <SelectDropdown
                            id="statusDropdown"
                            displayValue="name"
                            theme="search"
                            placeholder="Select Type"
                            intialValue={filter?.type}
                            isClearable={true}
                            result={(e) => handleFilters(e.value, "type")}
                            options={eventTypeOption}
                        />
                    </div>
                </div>
                <div className="p-5">
                    <div className="relative table-responsive overflow-x-auto border border-[#eee] sm:rounded-lg max-h-[600px]">
                        <table className="hover_bg w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 capitalize bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3">Event Name/Ticket Name</th>
                                    <th scope="col" className="px-6 py-3">Total Tickets</th>
                                    <th scope="col" className="px-6 py-3">Tickets Sold</th>
                                    <th scope="col" className="px-6 py-3">Tickets Available</th>
                                    <th scope="col" className="px-6 py-3">Total Sales</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eventTicketsData?.length === 0 && 
                                <tr className="text-center">
                                    <th colSpan={10} className="py-3">Data Not Found</th>
                                </tr>
                                }
                                {eventTicketsData && eventTicketsData?.map((item, index) => {
                                    return (
                                        <>
                                            <tr className="bg-white border-b hover:bg-gray-50 cursor-pointer" key={index} onClick={() => toggleRow(index)}>
                                                <th scope="row" className="px-6 py-4 whitespace-nowrap flex items-center">
                                                    {item?.tickets?.length > 0 && (
                                                        <span className="mr-2">
                                                            {expandedRows[index] ? '-' : '+'}
                                                        </span>
                                                    )}
                                                    {item?.title}
                                                </th>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    {item?.totalTickets}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    {item?.ticketsSold}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    {item?.ticketsAvilable}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    ${parseFloat(Number(item?.totalSales / 100)).toFixed(2)}
                                                </td>
                                            </tr>
                                            {expandedRows[index] && item?.tickets?.map((itm, i) => {
                                                return (
                                                    <tr className="bg-[#edf6ff] border-b hover:bg-gray-50" key={i}>
                                                        <th scope="row" className="px-6 py-1 whitespace-nowrap">
                                                            {itm?.ticket_name}
                                                        </th>
                                                        <td className="px-6 py-1 whitespace-nowrap">
                                                            {itm?.ticket_count}
                                                        </td>
                                                        <td className="px-6 py-1 whitespace-nowrap">
                                                            {itm?.buyed_tickets}
                                                        </td>
                                                        <td className="px-6 py-1 whitespace-nowrap">
                                                            {itm?.pending_tickets}
                                                        </td>
                                                        <td className="px-6 py-1 whitespace-nowrap"></td>
                                                    </tr>
                                                );
                                            })}
                                        </>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {total > filter?.count ? (
                        <div className="pagination_div w-[100%] text-right mx-auto">
                            <Pagination
                                activePage={filter?.page}
                                itemsCountPerPage={filter?.count}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                hideFirstLastPages
                                prevPageText="Previous"
                                nextPageText="Next"
                                itemClass="bg-white px-2 text-[#8f8f8f] rounded-md"
                                activeClass="!bg-[#005AAB] px-2 !text-white rounded-md"
                                onChange={e => handlePagination(e)}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    )
}

export default EventTicketTable